import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { createUseStyles } from "react-jss";
import { generateStreetFullName } from "Helpers/localeText";
import { HeaderTextSeo } from "ComponentsUI/SeoBlock";
import { useReviewsData } from "../../../hooks/useReviewsParams";

const useStyles = createUseStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.colors.transparent,
		paddingBottom: "60px",
	},
	reviewRoot: {
		marginRight: "20px",
	},
	controlRoot: {},
	wrapper: {
		display: "flex",
		flexDirection: "row",
	},
	onlyReviewsView: {
		justifyContent: "center",
	},
	withoutBottomPadding: {
		paddingBottom: "0px !important",
	},
	headerWrapper: {
		display: "grid",
		gridAutoFlow: "column",
		justifyContent: "space-between",
		paddingBottom: "12px",
		paddingLeft: "20px",
		alignItems: "end",
		gap: "20px",
		gridTemplateColumns: "1fr",
		gridAutoColumns: "auto",
	},
	headerText: {
		fontFamily: theme.fonts.bold,
		fontSize: "18px",
		lineHeight: 2,
		letterSpacing: "2px",
		color: theme.palette.colors.darkSlateBlue,
		margin: 0,
		padding: 0,
		textTransform: "uppercase",
		position: "relative",
		"&:after": {
			content: "''",
			position: "absolute",
			height: "2px",
			width: "79px",
			bottom: "-9px",
			left: 0,
			backgroundColor: theme.palette.colors.purplishBlue,
		},
	},
	headerTextWhite: {
		color: theme.palette.colors.white,
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		headerText: {
			"&:after": {
				width: "58px",
			},
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			paddingBottom: "40px",
		},
		headerText: {
			fontSize: "16px",
			lineHeight: 2.25,
			letterSpacing: "1.8px",
			marginLeft: "21px",
			"&:after": {
				width: "48px",
				bottom: "-8px",
			},
		},
		headerWrapper: {
			paddingLeft: "21px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			paddingBottom: "32px",
		},
		headerWrapper: {
			gridAutoFlow: "row",
			justifyContent: "unset",
			paddingLeft: "0",
			paddingBottom: 0,
			gap: 0,
		},
		headerText: {
			fontSize: "16px",
			lineHeight: 1,
			marginLeft: 0,
			"&:after": {
				display: "none",
			},
		},
		wrapper: {
			flexDirection: "column",
		},
		reviewRoot: {
			marginRight: 0,
		},
	},
}));

const BlockReviews = (props) => {
	let classes = useStyles();
	let {
		withoutBottomPadding,
		queryType,
		reviewLocation,
		text,
		reviews,
		onlyReviewsStyle,
		control,
		datatest,
		seoBlock,
	} = props;
	let headerText = "";

	const { houseFullInfo, streetFullInfo, regionFullInfo } = useReviewsData(
		queryType,
		reviewLocation
	);

	// if (houseFullInfo?.address_id && reviewLocation === "house") {
	// 	headerText = `${text.REVIEWS_RESIDENTS_HOUSE_1}${
	// 		houseFullInfo.house_full
	// 	}${text.REVIEWS_RESIDENTS_HOUSE_2}${generateStreetFullName({
	// 		type: houseFullInfo.socr,
	// 		name: houseFullInfo.street,
	// 	})}`;
	// } else if (streetFullInfo.id && reviewLocation === "street") {
	// 	headerText = `${text.REVIEWS_RESIDENTS_STREET_1}${generateStreetFullName({
	// 		type: streetFullInfo.type,
	// 		name: streetFullInfo.name,
	// 	})}`;
	// } else
	if (
		regionFullInfo &&
		(reviewLocation === "about_operator" ||
			reviewLocation === "operator_actions" ||
			reviewLocation === "operator_ratesmobile" ||
			reviewLocation === "ratesmobile_region")
	) {
		headerText = `${text.REVIEWS_RESIDENTS_REGION}${regionFullInfo.declinations?.genitive || ""}`;
	}

	return (
		<div
			className={classNames(classes.root, {
				[classes.withoutBottomPadding]: !seoBlock?.seoHeader && !headerText && !seoBlock?.seoText,
			})}
			datatest={datatest}
			id="fastReview"
		>
			<HeaderTextSeo header={seoBlock?.seoHeader || headerText} text={seoBlock?.seoText} />
			<div
				className={classNames(classes.wrapper, {
					[classes.onlyReviewsView]: onlyReviewsStyle,
				})}
			>
				{reviews && <div className={classes.reviewRoot}>{reviews}</div>}
				{control && <div className={classes.controlRoot}>{control}</div>}
			</div>
		</div>
	);
};

BlockReviews.prototypes = {
	queryType: PropTypes.string, // Тип запроса
	reviewLocation: PropTypes.string, // Место отзыва
	reviews: PropTypes.node,
	control: PropTypes.node,
	datatest: PropTypes.string,
	onlyReviewsStyle: PropTypes.bool,
	withoutBottomPadding: PropTypes.bool,
	text: PropTypes.object.isRequired,
};

export default BlockReviews;
